export interface ApiConfig {
  baseUrl: string;
  timeout: number;
  services: {
    gateway: string;
    identity: string;
    user: string;
    engagement: string;
    analytics: string;
    communication: string;
    wallet: string;
  };
}

export const apiConfig: ApiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://localhost:44318',
  timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
  services: {
    gateway: import.meta.env.VITE_SERVICE_GATEWAY_URL || import.meta.env.VITE_API_BASE_URL || 'https://localhost:44318',
    identity: import.meta.env.VITE_SERVICE_IDENTITY_URL || 'https://localhost:44311',
    user: import.meta.env.VITE_SERVICE_USER_URL || 'https://localhost:44366',
    engagement: import.meta.env.VITE_SERVICE_ENGAGEMENT_URL || 'https://localhost:44303',
    analytics: import.meta.env.VITE_SERVICE_ANALYTICS_URL || 'https://localhost:44369',
    communication: import.meta.env.VITE_SERVICE_COMMUNICATION_URL || 'https://localhost:44320',
    wallet: import.meta.env.VITE_SERVICE_WALLET_URL || 'https://localhost:44302'
  }
};

export const getServiceUrl = (service: keyof ApiConfig['services']): string => {
  return apiConfig.services[service];
};
